'use client'

import { Link, usePathname } from 'i18n/navigation';
import {useTranslations, useLocale, Locale} from 'next-intl';
import {routing} from 'i18n/routing';

import Image from 'next/image'
import gbFlagIcon from "images/flags/GB.svg";
import deFlagIcon from "images/flags/DE.svg";


export default function LocaleSwitcher() {
  const t = useTranslations('common');
  const locale = useLocale();
  const locales = routing.locales;

  const otherLocale : Locale = locales?.find((cur) => cur !== locale) as Locale;

  const countryIconSrc = (otherLocale == 'de') ? deFlagIcon : gbFlagIcon;  
  const titleText = (otherLocale == 'de') ? t("switch_to_german") : t("switch_to_english");
  const altText = (otherLocale == 'de') ? "German flag" : "Great Britain flag";

  const pathname = usePathname();
  
  return (
    <Link href={pathname}
      locale={otherLocale} 
      title={titleText}
      className="nav-link"
      tabIndex={0}
      role="button"
    >
      <Image width={20} height={14} alt={altText} src={countryIconSrc} />
    </Link>
  );
}